// extracted by mini-css-extract-plugin
export default {"wrapper":"SanitizedHtmlElement_wrapper__RipHE"};